import {TransportAssocEntity, transportCategory} from "@ots-frontend/ots-data";
import {Group, Text} from "@mantine/core";
import {IconDropletFilled} from "@tabler/icons-react";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {DefaultText} from "../../../../text/DefaultText/DefaultText";
import {DefaultTFuncReturn} from "i18next";

export const ServiceTypeCell = (props: { tta: TransportAssocEntity }) => {
  const {tta} = props

  const {t} = useTranslation(["common"])

  const serviceTypeId = useMemo(() => {
    return tta.pickupTransport?.serviceTypeId ?? tta.deliveryTransport?.serviceTypeId
  }, [tta])

  const serviceTypeName = useMemo(() => {
    return tta.pickupTransport?.serviceTypeName ?? tta.deliveryTransport?.serviceTypeName
  }, [tta])

  const rejected = useMemo(() => {
    return typeof (tta.pickupTransport?.rejectionType ?? tta.deliveryTransport?.rejectionType) !== 'undefined'
  }, [tta])

  const textColorRef = useMemo(() => {
    let colorRef: string | undefined = undefined

    if (rejected) {
      colorRef = "red"
    } else if (serviceTypeId) {
      colorRef = "service-work"
    }

    return colorRef
  }, [serviceTypeId, rejected])

  const icon = useMemo(() => {
    let color = "transport-category-water"

    if (!serviceTypeId && tta.category === transportCategory.oil) {
      if (rejected) {
        color = "red"
      } else {
        color = "transport-category-oil"
      }
    } else if (serviceTypeId) {
      color = "service-work"
    }

    return (
      <Text c={color}>
        <IconDropletFilled size={14}/>
      </Text>
    )
  }, [serviceTypeId, tta.category, rejected])


  const workType = useMemo(() => {
    let text : string | undefined | DefaultTFuncReturn = t("common.shared.normal", "Normal")

    if (rejected) {
      text = t("common.shared.rejected", "Rejected")
    } else if (serviceTypeId) {
      text = serviceTypeName
    }

    return text
  }, [rejected, serviceTypeId, serviceTypeName, t])

  return (
    <Text c={textColorRef}>
      <Group spacing="xs">
        {icon}
        <DefaultText value={workType}/>
      </Group>
    </Text>
  )
}
